export { WishlistHeadingDS } from './wishlist-heading-ds'
export type { WishlistHeadingDSProps } from './wishlist-heading-ds.types'
